import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
const axios = require("axios");

let ServerURL;

// Handler globale di gestione dell'errore del browser.
// Intercetta gli errori che non vengono gestiti prima dai try/catch oppure da Vue.config.errorHandler
window.onerror = function (messageOrEvent, source, lineno, colno) {
  let ServerURL = store.state.ServerURL;
  
  axios({
    method: "get",
    url:
      ServerURL +
      "CheckIn/RegistraErrore?errore=" + messageOrEvent + "&source=" + source + "&lineno=" + lineno + "&colno=" + colno,
    responseType: "json"
  })
  return true;
}

// Handler degli errori globale di Vue. Intercetta li errori che non vengonbo gestiti con try/catch
Vue.config.errorHandler = (error, vm) => {
  
  axios({
    method: "get",
    url:
      ServerURL +
      "CheckIn/RegistraErrore?errore=" + error.stack + "&source=" + vm._original.$vnode.tag + "&lineno=" + "0" + "&colno=" + "0",
    responseType: "json"
  })
};

try {

  // Imposto il tipo di b-select: plain per Chrome, standard per gli altri
  if (window.navigator.userAgent.indexOf("Chrome") >= 0)
  {
    store.commit("SettaSelectPlain", true);
  }
  else
  {
    store.commit("SettaSelectPlain", false);
  }
  
  // leggo la lingua del browser e imposto lo store di conseguenza
  let lingua = "";
  let userLang = navigator.language || navigator.userLanguage;
  if (userLang.toLowerCase().indexOf("it") >= 0) {
    lingua = "IT";
  }
  else if (userLang.toLowerCase().indexOf("en") >= 0) {
    lingua = "EN";
  }
  else if (userLang.toLowerCase().indexOf("de") >= 0) {
    lingua = "DE";
  }
  else if (userLang.toLowerCase().indexOf("fr") >= 0) {
    lingua = "FR";
  }
  else {
    lingua = "IT";
  }
  store.commit("SettaLingua", lingua);

  // imposto l'url del server e del client
  if (process.env.NODE_ENV === "production") {
    store.commit("SettaServerURL", "https://servercheckin.loquos.it/");
    store.commit("SettaLocalURL", "https://checkin.loquos.it/");
  } else {
    store.commit("SettaServerURL", "https://localhost:44380/");
    store.commit("SettaLocalURL", "http://localhost:8080/");
  }

  // inizializzo gli altri valori dello store
  store.commit("SettaUtenteAutenticato", false);
  store.commit("SettaPartner", false);
  store.commit("SettaAmministratore", false);
  store.commit("SettaUtente", "");
  store.commit("SettaPassword", "");
  store.commit("SettaStruttura", "");
  store.commit("SettaApplicazione", "");

  let ServerURL = store.state.ServerURL;

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')

  Vue.config.productionTip = false

  axios({
    method: "get",
    url:
      ServerURL + "Checkin/LeggiConfigurazione",
    responseType: "json"
  }).then(function (response) {
    if (response.data.errore == 0) {
      store.commit("SettaEmailFacileCheckIn", response.data.oggetto.email_amministratore);
    } else{
      store.commit("SettaEmailFacileCheckIn", "administrator@checkin.loquos.it");
    }
  });
}
catch (error) {
  router.push({ name: "Errore", params: { errore: error.stack } });
}
